module.exports = __webpack_public_path__ + "media/images/japan/location_arrow_1-c5d6c897eb2417045b29b8ca317719b9.svg";